/* eslint-env browser */

'use strict';

var Date = require('./Date');

function formatDate(d) {
	d = d || '';
	return d.replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$1/$2');
}

/**
 * @constructor
 * @extends Date
 */
var Datepicker = Date.extend('Datepicker', {
	/**
	 * @memberof Datepicker.prototype
	 * @override Date.prototype
	 */
	template: [
		'<input type="date" class="hypergrid-textfield" style="{{style}}">'
	].join(''),

	/**
	 * @memberOf Datepicker.prototype
	 * @override Date.prototype
	 */
	specialKeyups: {
		0x0d: 'stopEditing', // return/enter
		0x1b: 'cancelEditing' // escape
	},

	/**
	 * @memberof Datepicker.prototype
	 * @desc cleanup datepicker plugin
	 */
	cleanupDatepicker: function() {
		var jQuery = typeof window.jQuery !== 'undefined' && window.jQuery;
		if (jQuery && typeof jQuery.fn.datepicker !== 'undefined'){
			var $input = jQuery(this.input);
			if ($input.data('datepicker')) {
				$input.datepicker('hide').datepicker('destroy');
			}
		}
	},

	/**
	 * @memberof Datepicker.prototype
	 * @override Date.prototype
	 * @desc hide the editor
	 */
	hideEditor: function() {
		// Clean up datepicker
		this.cleanupDatepicker();
		this.el.style.display = 'none';
	},

	/**
	 * @memberOf Datepicker.prototype
	 * @override Date.prototype
	 * @param {string} value
	 */
	setEditorValue: function(value) {
		if (value) {
			// Get a yyyy-mm-dd string
			value = formatDate(value);
			this.input.value = value;
		}
	},

	/**
	 * @memberof Datepicker.prototype
	 * @override Date.prototype
	 * @desc display the editor
	 */
	showEditor: function() {
		var self = this;

		// If we are using the datepicker
		var jQuery = typeof window.jQuery !== 'undefined' && window.jQuery;
		if (jQuery && typeof jQuery.fn.datepicker !== 'undefined') {
			// Change to text so we do not get a browser ui conflict
			self.input.type = 'text';
			// Blur is not our concern here - if we exit on blur we would exit everytime someone tried using the datepicker
			self.el.onblur = function(e) {};
		}

		// Defer so the editor is actually in the DOM
		setTimeout(function() {
			// If we are using the datepicker
			if (jQuery && typeof jQuery.fn.datepicker !== 'undefined') {
				var $input = jQuery(self.input);
				$input
					// Init datepicker
					.datepicker({
						format: 'yyyy-mm-dd'
					})
					// Show
					.datepicker('show');

				// Prevent propagation while datepicker is open
				// otherwise the editor will close before the click gets through to the datepicker
				// We trigger `stopEditing` when a value is changed via the datepicker
				var dp = $input.data().datepicker;
				if (dp) {
					dp.picker
						.on('mousedown', function(e) {
							e.stopPropagation();
						})
						.on('click', function(e) {
							if (e.target.classList.contains('day')) {
								self.stopEditing();
							}
						});
				}
			}
		}, 0);

		// Show
		self.el.style.display = 'inline';
	}
});

module.exports = Datepicker;
